import { useCallback, useEffect, useState } from 'react';
import { NavPersona } from '../config/userNavMenu';
import {
  fetchSellerNavbarBadgeCount,
  fetchStaffNavbarBadgeCount,
} from '../services/api/navbarBadges.service';

const POLL_MS = 60_000;

export function useNavbarBadges(persona: NavPersona | 'guest', enabled: boolean) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!enabled || persona === 'guest' || persona === 'buyer') {
      setCount(0);
      return;
    }

    setLoading(true);
    try {
      if (persona === 'seller') {
        setCount(await fetchSellerNavbarBadgeCount());
      } else if (persona === 'owner' || persona === 'staff') {
        setCount(await fetchStaffNavbarBadgeCount());
      } else {
        setCount(0);
      }
    } catch {
      setCount(0);
    } finally {
      setLoading(false);
    }
  }, [enabled, persona]);

  useEffect(() => {
    void refresh();
    if (!enabled || persona === 'guest' || persona === 'buyer') return;

    const id = window.setInterval(() => {
      void refresh();
    }, POLL_MS);
    return () => window.clearInterval(id);
  }, [enabled, persona, refresh]);

  return { count, loading, refresh };
}
